import "./ErrorPage.css";
import React from 'react';
import history from "@safecv/shared/history";
import Lock_Icon from "../../assets/Images/lock_icon.png";

const ErrorPage = (props) => {
  return (
    <div className="error-container">

      <div className="margin-containers">
        <img 
          src={Lock_Icon}
          alt="Lock Icon"
          className="lock_icon_image"
        />
      </div>

      <div className="error-message margin-containers">
        <div className="error-data">
          You don't have the permission to view this page
        </div>
        <div>
          Please contact the administrator for the access
        </div>
      </div>

      <div className="error-button-container">
        <div
          className="error-buttons" 
          onClick={() => history.push("/plans")}
        >
          Go to Plans page
        </div>
      </div>

    </div>
  );
};

export default ErrorPage;
